import React from "react";
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>OMR Answer Key</h1>
                <p>Home &gt; OMR Answer Key</p>
            </div>
        </div>
    );
};

export default Hero;
